<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="查询编辑">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{
          $t("tab.tab_search_and_edit") }}</span>
        <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.48">
          <template #main>
            <TableMain ref="SOTable1" name="myName" :fields="fields" :title="table_title.title1"
              :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="false"
              :show_toolbar="true" :show_credit_approved="true" :approvedStr="'approve_order'"
              :unapprovedStr="'unapprove_order'" :show_price_approved="true" :show_filter="true" :show_copy="true"
              :selectable="true" :hb_table_class="'hb_table_so_class1'" :table_height_adjust="-8"
              :isBusy="isBusy_table1" :loading_width="30" @on_query="on_query"
              @on_cell_button_click="on_cell_button_click" @on_input="on_input" @state_change="state_change"
              :show_toolbar_button="[0, 0, 1, 1, 1]" @tool_invoke="tool_invoke" :show_email="true"
              @email_invoke="SendEmail" @current_changed="current_changed" tableref="740047cf4f554b539a5e96eaf139b448">
              <template #query>
                <el-select v-model="dateChoose" placeholder="" size="small" style="width: 100px">
                  <el-option :label="$t('common.delivery_date')" value="date1"></el-option>
                  <el-option label="创建日期" value="date2"></el-option>
                </el-select>
                <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
                  align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
                  :picker-options="pickerOptions()">
                </el-date-picker>
                {{ $t("common.sales_order_num") }}：<el-input size="small" style="width: 120px" clearable
                  v-model="SalesId"></el-input>
              </template>
              <template #toolbar>
                <el-button type="info" plain @click="createForm('new')" class="ml-2 iconfont icon-add-new" size="mini">
                  {{ $t("common.new") }}
                </el-button>
                <el-checkbox :label="$t('common.my_approval')" v-model="onlyMyApproved" class="ml-2"
                  @change="myApproveChange"></el-checkbox>
              </template>
            </TableMain>
          </template>
          <template #top>
            <TableMain ref="SOTable2" :show_query_container="false" :show_date_picker="false"
              :fields="inventTable_fields" :table_height_adjust="8" :title="table_title.title2"
              :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
              :pager_count="5" :isBusy="isBusy_table2" :only_text="$t('common.show_customer_all')"
              :only_text1="$t('common.pub_invent')" :hb_table_class="'hb_table_so_class2'" @only_methods="only_methods"
              tableref="e302b0d882964a2288ed0b033102162f">
              <template #operation>
                <el-button type="info" plain class="ml-2" @click="SOTable2_Cell_Chose"><i
                    class="iconfont icon-down2"></i>&nbsp;&nbsp;{{ $t("common.selected") }}
                </el-button>
              </template>
            </TableMain>
          </template>
          <template #bottom>
            <TableMain ref="SOTable3" :fields="detail_fields" :show_query_container="false" :title="table_title.title3"
              :date_picker_label="date_picker_label" :table_height_adjust="-2" :show_pagination="show_pagination"
              :show_filter="false" :hb_table_class="'hb_table_so_class3'" :pager_count="5" :isBusy="isBusy_table3"
              :loading_width="45" @state_change="SOTable3_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
              @on_input="table3_on_input" @on_change="table3_on_change" tableref="02dc1ea34bda40af8f32321495ffa16a">
              <template #operation>
                <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
                  @on_query="SOTable3_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
              </template>
            </TableMain>
          </template>
        </SplitContainer3>
      </el-tab-pane>
      <el-tab-pane label="明细列表">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_detail")
        }}</span>
        <SalesOrderItems ref="SalesOrderItemsTable"></SalesOrderItems>
      </el-tab-pane>
      <el-tab-pane label="导入">
        <span slot="label"><i class="iconfont icon-export-in" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_import")
        }}</span>
        <SaleOrderExport></SaleOrderExport>
      </el-tab-pane>
      <el-tab-pane label="COPACKING">
        <span slot="label"><i class="fa fa-copy" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_copacking") }}</span>
        <saleOrderCopacking></saleOrderCopacking>
      </el-tab-pane>
    </el-tabs>
    <!-- 信用额度审批 -->
    <BaseModal ref="ApprovedCredit" title="信用额度审批" @saveData="saveApprovedCredit" :saveButtonTitle="'审批通过'"
      :width="'25%'" :top="'8vh'">
      <template #modal_content>
        <el-form :model="creditdataForm" :rules="rules" ref="dataForm" label-width="150px" class="demo-dataForm"
          style="height: 200px">
          <el-col :span="24">
            <el-form-item label="总信用额度:" prop="creditMax">
              <div class="token">
                <strong>{{ creditdataForm.creditMax }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="已使用额度:" prop="dispUsedCreditAmount">
              <div class="token">
                <strong>{{ creditdataForm.dispUsedCreditAmount }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="平台已使用额度:" prop="PlantUsedCreditAmount">
              <div class="token">
                <strong>{{ creditdataForm.PlantUsedCreditAmount }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="本次确认金额:" prop="orderAmount">
              <div class="token">
                <strong>{{ creditdataForm.orderAmount }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="信用余额:" prop="balance">
              <div class="token">
                <strong :class="textColor">{{ creditdataForm.balance }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="未到期应收:" prop="dispopenInvoiceBalanceMSTDue0">
              <div class="token">
                <strong>{{
                  creditdataForm.dispopenInvoiceBalanceMSTDue0
                }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="超15天内的应收:" prop="dispopenInvoiceBalanceMSTDue_N">
              <div class="token">
                <strong>{{
                  creditdataForm.dispopenInvoiceBalanceMSTDue_N
                }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="超15天及以上的应收:" prop="dispopenInvoiceBalanceMSTDueAbove_N">
              <div class="token">
                <strong>{{
                  creditdataForm.dispopenInvoiceBalanceMSTDueAbove_N
                }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="超30天内的应收:" prop="dispopenInvoiceBalanceMSTDue30">
              <div class="token">
                <strong>{{
                  creditdataForm.dispopenInvoiceBalanceMSTDue30
                }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="超31至60天的应收:" prop="dispopenInvoiceBalanceMSTDue31_60">
              <div class="token">
                <strong>{{
                  creditdataForm.dispopenInvoiceBalanceMSTDue31_60
                }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="超60天的应收:" prop="dispopenInvoiceBalanceMSTDue60Above">
              <div class="token">
                <strong>{{
                  creditdataForm.dispopenInvoiceBalanceMSTDue60Above
                }}</strong>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审批意见:" prop="approved_comment">
              <el-input v-model="creditdataForm.approved_comment" placeholder="请输入审批意见" size="mini" type="textarea"
                rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm"
          style="height: 240px">
          <el-col :span="12">
            <el-form-item label="客户" prop="CustAccount">
              <el-select size="small" v-model="dataForm.CustAccount" filterable clearable placeholder="请选择客户"
                class="w-100" :loading="select_loading" @change="cutChanged" :filter-method="filterMethod"
                @focus="filterMethod(dataForm.CustAccount)">
                <el-option v-for="item in cust_options" :key="item.AccountNum"
                  :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="销售公司" prop="dataAreaId">
              <el-select size="small" v-model="dataForm.dataAreaId" filterable clearable placeholder="请选择销售公司"
                @change="dataAreaChanged" class="w-100">
                <el-option v-for="item in company_options" :key="item.dataAreaId"
                  :label="item.dataAreaId + ':' + item.dataAreaName" :value="item.dataAreaId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="最终客户" prop="TEC_FinalCustAccount">
              <el-select size="small" v-model="dataForm.TEC_FinalCustAccount" filterable clearable placeholder="请选择最终客户"
                class="w-100" :loading="select_loading" :filter-method="filterMethod"
                @focus="filterMethod(dataForm.TEC_FinalCustAccount)">
                <el-option v-for="item in cust_options" :key="item.AccountNum"
                  :label="item.AccountNum + ':' + item.SEI_Name" :value="item.AccountNum"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.order_pool')" prop="SalesPoolId">
              <el-select size="small" v-model="dataForm.SalesPoolId" filterable clearable placeholder="请选择订单池"
                class="w-100">
                <el-option v-for="item in getBaseDataSOPool(dataForm.dataAreaId)" :key="item.SalesPoolId"
                  :label="item.SalesPoolId" :value="item.SalesPoolId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('common.delivery_date')" prop="DeliveryDate">
              <el-date-picker size="small" type="date" placeholder="选择装运日期" v-model="dataForm.DeliveryDate"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="送货地址" prop="DeliveryAddress">
              <el-select size="small" v-model="dataForm.DeliveryAddress" filterable clearable placeholder="请选择送货地址"
                class="w-100">
                <el-option v-for="item in delivery_address_options_group" :key="item.DeliveryAddress"
                  :label="item.DeliveryAddress" :value="item.DeliveryAddress"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="币种" prop="CurrencyCode">
              <!-- {{ dataForm.CurrencyCode }} -->
              <el-select size="small" v-model="dataForm.CurrencyCode" filterable clearable placeholder="请选择币种"
                class="w-100" @change="CurrencyChanged">
                <el-option v-for="item in $store.state.biz_data.baseData.Currency" :key="item.CurrencyCode"
                  :label="item.CurrencyCode + ':' + item.Txt" :value="item.CurrencyCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="汇率" prop="ExchRate">
              <el-input type="text" v-model="dataForm.ExchRate" :disabled="dataForm.CurrencyCode == 'CNY'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="包括销售税">
              <el-select size="small" v-model="dataForm.InclTax" filterable clearable placeholder="" disabled
                class="w-100">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="销售税组" prop="TaxGroup">
              <el-select size="small" v-model="dataForm.TaxGroup" filterable clearable placeholder="请选择税组"
                class="w-100">
                <el-option v-for="item in getBaseDataTaxGroup(dataForm.dataAreaId)" :key="item.TaxGroup"
                  :label="item.TaxGroup + ':' + item.TaxGroupName" :value="item.TaxGroup"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注" prop="TEC_Remark">
              <el-input type="textarea" v-model="dataForm.TEC_Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import numbro from "numbro"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as CustTableController from "../../controllers/base/CustTableController"
import * as ExchRateController from "../../controllers/base/ExchRateController"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from "../../controllers/commonController"
import * as SOApprovedController from "../../controllers/sd/SOApprovedController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as notify_template from "../../shared/notify_template"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableDetail from "../components/table/TableDetail"
import TableMain from "../components/table/TableMain"

import BaseModal from "../components/modals/baseModal"
import SalesOrderItems from "./SalesOrderItems"
import saleOrderCopacking from "./saleOrderCopacking"
import SaleOrderExport from "./saleOrderExport"

export default {
  name: "SalesOrder",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer3,
    BaseModal,
    SaleOrderExport,
    saleOrderCopacking,
    SalesOrderItems,
  },
  data() {
    return {
      tab_index: 0,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sales_order",
        title2: "table_invent",
        title3: "table_sales_order_detail",
      },
      modal_title: "新建销售订单",
      SalesId: "",
      InventCode: "",
      fields: SalesOrderController.fields.default,
      detail_fields: SalesOrderController.fields.detail_fields,
      inventTable_fields: SalesOrderController.fields.inventTable_fields,
      dataForm: _.cloneDeep(SalesOrderController.dataForm),
      creditdataForm: _.cloneDeep(SalesOrderController.creditdataForm),
      dataItemForm: _.cloneDeep(SalesOrderController.dataItemForm),
      rules: SalesOrderController.rules,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      show_pagination: true,
      select_loading: false,
      cust_options: [],
      company_options: [],
      invent_retail_options: [],
      his_order_list: [],
      his_order_line_data: [],
      all_role_users: [],
      all_role_list: [],
      delivery_address_options: [],//送货地址
      delivery_address_options_group: [],//送货地址
      onlyMyApproved: false,
      SaleAreaid: "", ///客户默认销售公司
      textColor: "",
      current_click_so: null,
      dateChoose: "date2",
      date_range: "",
    }
  },
  async created() {
    let _this = this
    let _field = _.find(this.detail_fields, {
      key: "RetailVariantId",
    })
    _field["_options"] = {
      base_on_field: "ItemId",
      provider: (v) => {
        return _.map(_this.setInventData(v), (t) => {
          return { value: t.RetailVariantId, label: t.VariantName } //VariantName
        })
      },
    }
    _field = _.find(this.detail_fields, {
      key: "DW_inventBatchIdSales",
    })
    _field["_options"] = {
      base_on_field: "dataAreaId",
      provider: (v) => {
        let _lt = _this.setLoactionData(v)
        return _.map(_lt, (t) => {
          return {
            value: t.InventLocationId,
            label: t.InventLocationValue,
            disable: t.disable,
          } //VariantName
        })
      },
    }
    _field = _.find(this.detail_fields, {
      key: "DeliveryAddress",
    })
    _field["_options"] = {
      base_on_field: "ItemId",
      provider: (v) => {
        let _filter_options = _.uniqBy(_.filter(this.delivery_address_options, { ItemRelation: v }), "DeliveryAddress")
        return _.map(_filter_options, (t) => {
          return {
            value: t.DeliveryAddress,
            label: t.DeliveryAddress
          }
        })
      },
    }
    await this.getAllRoles()
    await this.getAllRoleUsers()
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
  },

  watch: {
    "$route": {
      handler(val) {
        if (val) {
          this.SalesId = val.query.k
          this.on_query(this.$refs.SOTable1.SetData)
        }
      },
      deep: true
      // immediate: true
    },
  },

  methods: {
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.filter(_dt, { is_sys: false, is_valid: true })
    },
    setLoactionData(dropdownSearchValue) {
      let _list = []
      let soItem = this.$refs.SOTable1.GetCurrentItem()
      if (soItem) {
        let loactions = _.filter(
          this.$store.state.biz_data.baseData.InventLocation,
          { dataAreaId: soItem.dataAreaId }
        )
        let loactions_options = loactions
        if (loactions_options.length > 0) {
          _.each(loactions_options, (t) => {
            let _index = _.findIndex(_list, {
              InventLocationId: t.InventLocationId,
            })
            if (_index < 0) {
              _list.push({
                InventLocationId: t.InventLocationId,
                InventLocationValue:
                  t.InventLocationId + ":" + (t.Name == null ? "" : t.Name),
                disable: t.is_valid,
              })
            }
          })
        }
      }
      return _list
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region table1
    ///查询
    async on_query(set_data) {
      let _this = this
      this.isBusy_table1 = true
      this.dataForm = _.cloneDeep(SalesOrderController.dataForm)
      this.dataItemForm = _.cloneDeep(SalesOrderController.dataItemForm)

      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = { is_deleted: { "=": 0 } }
      if (this.SalesId && this.SalesId != "") {
        _params.SalesId = { like: "%" + this.SalesId + "%" }
      }
      if (!_.isNull(this.date_range) && this.SalesId == "") {
        _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        if (this.dateChoose == "date2") {
          _params["create_at"] = { ">=": _fromDate, "<=": _toDate }
        } else {
          _params["DeliveryDate"] = { ">=": _fromDate, "<=": _toDate }
        }
      }
      let _result = await SalesOrderController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = []
        _.each(_result[0], (t) => {
          let _index = _.findIndex(
            _this.$store.state.biz_data.userInfo.user_custs,
            { AccountNum: t.CustAccount }
          )
          if (_index > -1) {
            t.DeliveryDate = this.formatDate(t.DeliveryDate, "yyyy-MM-dd HH:mm:ss")
            let __index = _.findIndex(_this.$store.state.biz_data.baseData.Customer,
              {
                AccountNum: t.CustAccount,
              }
            )
            if (__index > -1) {
              t.SEI_BigCustomerNumber =
                _this.$store.state.biz_data.baseData.Customer[
                  __index
                ].SEI_BigCustomerNumber
            }
            this.getApprover(t)

            _list.push(t)
          }
        })
        this.his_order_list = _.orderBy(_list, ["id"], ["desc"])
        console.log(this.his_order_list)

        set_data(_.orderBy(_list, ["id"], ["desc"]))
      }
      this.isBusy_table1 = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOApprover",
        "SOApprover",
        t.fcCheckSOApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOCreditControlApprover",
        "SOCreditControlApprover",
        t.fcCheckSOCreditControlApproved
      )
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetSOPriceDiffApprover",
        "SOPriceDiffApprover",
        t.fcCheckSOPriceDffApproved
      )
    },
    ///初始化so编辑界面
    async createForm(code) {
      let title = ""
      this.getBaseDataCust(code)
      switch (code) {
        case "new":
          title = "新建销售订单"
          this.dataForm = _.cloneDeep(SalesOrderController.dataForm)
          if (this.$refs.dataForm) {
            this.$refs.dataForm.resetFields()
          }
          this.current_click_so = null
          break
        case "edit":
          title = "编辑销售订单"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },

    ///新增修改so
    async saveData(cb) {
      let _this = this
      let _data = _.cloneDeep(_this.dataForm)
      let check_empty = true, msg = ""
      if (_data.CustAccount == "") {
        check_empty = false
        msg = "请选择客户"
      }
      else if (_data.dataAreaId == "") {
        check_empty = false
        msg = "请选择销售公司"
      }
      else if (_data.TEC_FinalCustAccount == "") {
        check_empty = false
        msg = "请选择最终客户"
      }
      else if (_data.SalesPoolId == "") {
        check_empty = false
        msg = "请选择订单池"
      }
      else if (!_data.DeliveryDate) {
        check_empty = false
        msg = "请选择交货日期"
      }
      else if (_data.TaxGroup == "") {
        check_empty = false
        msg = "请选择销售税组"
      }
      else if (_data.ExchRate == "" || _data.ExchRate == 0) {
        check_empty = false
        msg = "汇率不能为空或0"
      }

      if (!check_empty) {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }
      _data.DeliveryDate = this.$date.format(
        new Date(_data.DeliveryDate),
        "yyyy-MM-dd"
      )
      //已审核不能修改
      let _order = _.find(_this.$refs.SOTable1.my_data, { id: _data.id })
      if (
        _order &&
        _order.fcCheckSOApproved == true &&
        _order.fcCheckSOCreditControlApproved == true &&
        _order.fcCheckSOPriceDffApproved == true
      ) {
        _this.msgToasts(this.$t("notify.approved_can_not_be_edited"), "info")
        cb(null)
        return
      }

      ///新建时检查日期是否超过当前服务器日期
      let _is_date_ok =
        await commonController.methods.checkIsBeforeCurrentDate(
          _data.DeliveryDate
        )
      if (!_is_date_ok && _data.id == "") {
        _this.msgToasts(this.$t("notify.delivery_date_not_more_current_date"), "info")
        cb(null)
        return
      }
      ///查询客户相关信息
      if (_data.CustAccount) {
        let _m = _.find(this.$store.state.biz_data.baseData.Customer, {
          AccountNum: _data.CustAccount,
        })
        if (_m) {
          _data.SalesName = _m.SEI_Name
          // _data.InclTax = _m.InclTax;

          this.dataForm.TEC_FinalCustAccount = this.dataForm.CustAccount
        }
        let _m1 = _.find(this.$store.state.biz_data.baseData.Customer, {
          AccountNum: _data.TEC_FinalCustAccount,
        })
        if (_m1) {
          _data.TEC_FinalCustomerName = _m1.SEI_Name
        }
      }
      ///修改时重新编辑订单金额
      if (_.isInteger(_data.id)) {
        ///检查是否修改客户
        if (!_.isNull(this.current_click_so)) {
          let _current_so = _.cloneDeep(this.current_click_so)
          let _result = await SalesOrderController.methods.getItemData({
            SalesTable_id: _current_so.id,
          })
          if (
            _current_so.CustAccount != this.dataForm.CustAccount ||
            _current_so.CurrencyCode != this.dataForm.CurrencyCode ||
            _current_so.ExchRate != this.dataForm.ExchRate ||
            _current_so.dataAreaId != this.dataForm.dataAreaId
          ) {
            if (
              !_.isNull(_result) &&
              _result &&
              _result.length > 0 &&
              _result[0] &&
              _result[0].length > 0
            ) {
              let _filter_list = _.filter(_result[0], {
                is_deleted: false,
              })
              if (_filter_list.length > 0) {
                this.msgToasts(
                  "该销售订单已产生销售订单明细，不能被修改！",
                  "info"
                )
                cb(null)
                return
              }
            }
          }
        }

        ///转换金额
        let _amount_m = {
          currency: _data.CurrencyCode,
          amount: _data.OrderAmount,
          incTax: _data.InclTax == "是" ? 1 : 0,
          taxGroup: _data.TaxGroup,
          dataAreaId: _data.dataAreaId,
        }
        let _cnyAmount_m =
          await SalesOrderController.methods.getLocalAmountWOTaxData(
            _amount_m
          )

        if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
          if (!_.isNull(_cnyAmount_m[0][0].CNYAmount)) {
            _data.OrderAmountTax = _cnyAmount_m[0][0].CNYAmount
          }
          if (!_.isNull(_cnyAmount_m[0][0].CNYAmountWOTax)) {
            _data.OrderAmountWOTax = _cnyAmount_m[0][0].CNYAmountWOTax
          }
        }

        ///检查客户信用额度(退货不检查)
        let _msg = ""
        let cust_credit = await this.getCustCredit(_data.CustAccount)

        let _CreditMax =
          cust_credit.CreditMax +
          cust_credit.Temp_CreditMax -
          cust_credit.dispUsedCreditAmount -
          cust_credit.PlantUsedCreditAmount
        _data.CreditMax = parseFloat(cust_credit.CreditMax)
        _data.Temp_CreditMax = parseFloat(cust_credit.Temp_CreditMax)
        _data.dispUsedCreditAmount = parseFloat(
          cust_credit.dispUsedCreditAmount
        )
        _data.CustomerNotDispatchAmt = parseFloat(
          cust_credit.PlantUsedCreditAmount
        )
        if (
          _data.OrderAmountWOTax > 0 &&
          _data.OrderAmountWOTax > _CreditMax
        ) {
          let total_credit = _.round(
            _data.CreditMax + _data.Temp_CreditMax,
            2
          )
          _msg =
            "信用额度不足（当前订单金额：" +
            _.round(_data.OrderAmountTax, 2) +
            "，剩余信用额度：" +
            _.round(_CreditMax, 2) +
            "；信用额度+临时信用额度：" +
            _.round(total_credit, 2) +
            "，已使用信用额度：" +
            _.round(_data.dispUsedCreditAmount, 2) +
            "，平台已使用信用额度：" +
            _.round(cust_credit.PlantUsedCreditAmount, 2) +
            "）；"
        }
        //检查账期
        if (cust_credit && cust_credit.overDueDay) {
          _msg += "存在超期应收货款；"
        }
        if (_msg != "") {
          cb(false)
          let _is_con = true
          await this.msgModal(_msg).then((value) => {
            if (!value) {
              _is_con = false
            }
          })
          if (!_is_con) {
            return
          }
        }
      }

      _data.documentCreateByUsername =
        this.$global.global_data.local_username

      ///保存数据
      let _rel_save_data =
        await SalesOrderController.methods.saveSalesOrder(
          _data,
          this.$global.global_data.local_username
        )
      if (!_.isNull(_rel_save_data)) {
        ///成功
        cb(true, true)
        if (_.isInteger(_data.id)) {
          let cust_m = _.find(
            this.$store.state.biz_data.baseData.Customer,
            { AccountNum: _data.CustAccount }
          )
          if (cust_m) {
            _data.SEI_BigCustomerNumber = cust_m.SEI_BigCustomerNumber
          }
          _data.is_email_send = false
          this.$refs.SOTable1.UpdateItems({ id: _data.id }, _data)
        } else {
          _rel_save_data[0].create_by_username =
            this.$global.global_data.local_username
          _rel_save_data[0].update_by_username =
            this.$global.global_data.local_username
          let cust_m = _.find(
            this.$store.state.biz_data.baseData.Customer,
            { AccountNum: _data.CustAccount }
          )
          if (cust_m) {
            _rel_save_data[0].SEI_BigCustomerNumber =
              cust_m.SEI_BigCustomerNumber
          }
          // _rel_save_data[0].DeliveryDate = this.$date.format(_rel_save_data[0].DeliveryDate, "yyyy-MM-dd")

          this.$refs.SOTable1.InsertItems(_rel_save_data[0])
        }
        ///同步客户信息并更新vuex
        this.InvokeData(_data.CustAccount)
      } else {
        ///失败
        cb(true, false, "")
      }
    },
    ///同步当前选中客户信息
    async InvokeData(_accountNum) {
      let _params = {
        company: "070",
        tableName: "secp_sei_custtable",
        accountNum: _accountNum,
      }
      let _result = await CustTableController.methods.pickAndInvoke(_params)
      if (!_.isNull(_result) && _result && _result.status == 0) {
        ///更新vuex 数据
        this.$store.commit("update_biz_data", {
          content_path: "biz_data.baseData",
          content_type: "Customer",
          search_by: { AccountNum: _accountNum },
          data: _result.data[0],
        })
      }
    },

    ///so_order_main click
    async on_cell_button_click(data) {
      this.$refs.SOTable1.SetCurrentItem(data.item)
      let _this = this
      ///判断是否是自己创建的数据
      if (!commonController.methods.checkIfCanModifyOrder(this, data.item)) {
        return
      }
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.current_click_so = _.cloneDeep(data.item)

      this.dataForm.DeliveryDate = new Date(this.dataForm.DeliveryDate) // this.$date.format(new Date(this.dataForm.DeliveryDate), "yyyy-MM-dd");
      console.log(this.dataForm.DeliveryDate)
      let _result = await CustTableController.methods.getItemData({
        AccountNum: { "=": this.dataForm.CustAccount },
      })

      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          let _dataArea_m = _.find(
            this.$store.state.biz_data.baseData.CompanyInfo,
            { DataArea: t.dataAreaId }
          )
          if (_dataArea_m) {
            let _cut_m = _.find(_this.$store.state.biz_data.baseData.Customer, {
              AccountNum: _dataArea_m.CustAccountNum,
            })
            t.dataAreaName = _cut_m.SEI_Name
          }
        })
        this.company_options = _.orderBy(_result[0], ["id"], ["asc"])
      }

      this.createForm("edit")
    },
    on_input(data) {

    },
    async saveApprovedCredit(cb) {
      let so_table1_selected = this.$refs.SOTable1.GetSelectedItems()
      if (so_table1_selected && so_table1_selected.length > 1) {
        this.msgToasts(this.$t("notify.credit_must_action_one_line"), "info")
        cb(false)
        return
      }
      let _select_list = _.cloneDeep(so_table1_selected[0])

      let _list = []
      let _update_status_list = []
      let m = {
        type_code: "credit",
        id: _select_list.id,
        approved_comment: this.creditdataForm.approved_comment,
        is_so_approved: true,
      }
      _list.push(m)
      ///检查是否有该权限
      let _check_ap_params = {
        list: so_table1_selected,
        DocumentType: "SalesOrder",
        approve_type: "credit_control",
        isNotCheckPrivilage: false,
        action_state: true,
      }
      let check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
      _update_status_list = check_ap_res.approveStatusIdList

      let result = await SOApprovedController.methods.approveData(
        _list,
        this.$global.global_data.local_username,
        _update_status_list
      )
      if (result) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        if (_list.length > 0) {
          let _tm = _.find(this.$refs.SOTable1.my_data, { id: _list[0].id })
          if (_tm) {
            _tm.approved_comment = this.creditdataForm.approved_comment
          }
        }
        cb(true, true)
        if (this.$refs.SOTable1.my_data.length > 0) {
          _.each(_list, (t) => {
            let _m = _.find(this.$refs.SOTable1.my_data, {
              id: t.id,
            })
            if (_m) {
              _m.fcCheckSOCreditControlApproved = true
              let _ap_list = _.find(_update_status_list, { ItemId: t.id })
              if (_ap_list) {
                _m.SOCreditControlApprover = ""
              }
            }
          })
        }

        ///审批成功后发邮件
        let _ep = {
          notify_type: "credit_approve_pass",
          subject: "credit_approve_pass",
          idx: "SalesId",
        }
        await this.sendEmailAfterApproved(so_table1_selected, _ep)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    ///so_order_main state change
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }

      ///清空明细数据
      this.$refs.SOTable3.SetData([])

      let check_ap_res = [] //审批的集合
      let _state = false
      let _msg = "反审"
      let state_list = ["approved", "credit_approved", "price_approved"]
      if (state_list.includes(data.state)) {
        _msg = "审核"
        _state = true
      }

      let documentType = "SalesOrder"
      let approveType = ""
      let approve_state_field = ""
      if (data.state === "approved" || data.state === "unapproved") {
        approve_state_field = "fcCheckSOApproved"
      } else if (
        data.state == "credit_approved" ||
        data.state == "credit_unapproved"
      ) {
        approveType = "credit_control"
        approve_state_field = "fcCheckSOCreditControlApproved"
      } else if (
        data.state == "price_approved" ||
        data.state == "price_unapproved"
      ) {
        approveType = "price_diff"
        approve_state_field = "fcCheckSOPriceDffApproved"
      }

      //#region 检查
      ///删除时判断是否是自己创建的数据和是否已经审批的数据
      if (data.state === "deleted") {
        let _is_my_data = true
        let _has_approve = true
        _.each(data.selected_items, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            _is_my_data = false
          } else if (t.fcCheckSOApproved == true) {
            _has_approve = false
          }
        })
        if (!_is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"))
          cb(false)
          return
        } else if (!_has_approve) {
          this.msgToasts("抱歉，已审批数据不能被删除！", "info")
          cb(false)
          return
        }

        //检查能否删除
        let rt_check = await SalesOrderController.methods.checkUnApprove(
          data.selected_items
        )
        if (!_.isNull(rt_check) && !rt_check.state) {
          this.msgToasts(rt_check.message, "info")
          cb(false)
          return
        }
      }
      //销售退货及不是当前用户创建的订单不能反审
      if (
        data.state === "unapproved" ||
        data.state === "credit_unapproved" ||
        data.state === "price_unapproved"
      ) {
        let _is_return_data = true
        let _is_my_data = true
        _.each(data.selected_items, (t) => {
          // if (t.is_return_so) {
          //   _is_return_data = false;
          // }
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            _is_my_data = false
          }
        })
        if (!_is_return_data) {
          this.msgToasts(this.$t("notify.sales_return_can_not_unapproved"))
          cb(false)
          return
        } else if (!_is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"))
          cb(false)
          return
        }
      }
      //审批权限及是否操作了相同类型
      if (data.state != "deleted" && data.state != "copy") {
        ///检查是否有该权限
        let _check_ap_params = {
          list: data.selected_items,
          DocumentType: documentType,
          approve_type: approveType,
          isNotCheckPrivilage: _state ? false : true,
          action_state: _state,
        }
        check_ap_res = await commonController.methods.checkApprovePrivilige(_check_ap_params, this)
        if (check_ap_res.notPriviligeIdList.length > 0) {
          this.msgToasts(
            "抱歉，暂无审批订单编号（" +
            _.join(check_ap_res.notPriviligeIdList, "，") +
            "）的权限！",
            "error"
          )
          cb(false)
          return
        }
        //判断当前数据是否和当前操作类型相同
        if (
          this.checkIsApproved(data.selected_items, approve_state_field, _state)
        ) {
          this.msgToasts(this.$t("notify.has_approved_or_unapproved"))
          cb(false)
          return
        }
      }
      //#endregion
      if (data.state === "deleted") {
        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            let result = await SalesOrderController.methods.deleteData(
              data.selected_items
            )
            if (!_.isNull(result)) {
              let _is_check_list = []
              _.each(
                _.filter(result, { Code: "data/e/delete_salesorder" }),
                (t) => {
                  if (!_.isNull(t.Result) && t.Result.Rollback) {
                    _is_check_list.push(t.Params.id)
                  }
                }
              )
              if (_is_check_list.length > 0) {
                let _msg = "抱歉，编号：" + _.toString(_is_check_list) + "，已生成明细不能被删除！"
                this.msgToasts(_msg, "info")
                cb(false)
              } else {
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                //#region 删除邮件
                let notify_list = []
                _.each(data.selected_items, (t) => {
                  ///普通审批邮件
                  notify_list.push({
                    idx: t.SalesId,
                    notify_type: "so_approve",
                  })
                  ///信用邮件
                  notify_list.push({
                    idx: t.SalesId,
                    notify_type: "credit_approve",
                  })
                  ///价格不一致
                  notify_list.push({
                    idx: t.SalesId,
                    notify_type: "price_approve",
                  })
                })
                if (notify_list.length > 0) {
                  await commonController.methods.sendOrCancelNotify(
                    "cancel",
                    notify_list
                  )
                }
                cb(true)
                this.$refs.SOTable3.SetData([])
                //#endregion
              }
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      } else if (data.state === "approved" || data.state === "unapproved") {
        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            let _update_status_list = check_ap_res.approveStatusIdList
            let result = await SalesOrderController.methods.approveData(
              this.$global.global_data.local_username,
              _update_status_list
            )
            if (result) {
              //修改审批人及状态
              this.updateApproverAndState(
                data,
                _update_status_list,
                _state,
                "fcCheckSOApproved",
                "SOApprover"
              )

              if (_state) {
                ///审批成功后发邮件
                let _ep = {
                  notify_type: "so_approve_pass",
                  subject: "so_approve_pass",
                  idx: "SalesId",
                }
                await this.sendEmailAfterApproved(data.selected_items, _ep)
              }
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'SalesOrder', data, this)
              cb(false)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
          else {
            await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, 'SalesOrder', data, this)
          }
        })
      } else if (data.state == "credit_approved") {
        //获取相关信息加载
        let _params = {
          company: data.selected_items[0].dataAreaId,
          tableName: "secp_SEI_CustTable2",
          accountNum: data.selected_items[0].CustAccount, //不传则查询所有
        }

        let _res_credit = await CustTableController.methods.pickAndInvoke(
          _params
        )
        console.log(_res_credit)
        if (!_.isNull(_res_credit) && _res_credit && _res_credit.status != 0) {
          this.msgToasts(this.$t("notify.ax_error") + "：" + _res_credit.message, "error")
          cb(true)
          return
        } else if (_.isNull(_res_credit)) {
          this.msgToasts(this.$t("notify.ax_call_failed"), "error")
          cb(true)
          return
        }

        let _gt_credit = _res_credit.data
        if (_gt_credit.length == 0) {
          this.msgToasts(this.$t("notify.cust_has_not_credit"), "error")
          cb(true)
          return
        }

        //获取客户信用额度
        let cust_credit = await this.getCustCredit(
          data.selected_items[0].CustAccount
        )
        console.log(cust_credit)
        let _balance_CreditMax =
          cust_credit.CreditMax +
          cust_credit.Temp_CreditMax -
          cust_credit.dispUsedCreditAmount -
          cust_credit.PlantUsedCreditAmount +
          data.selected_items[0].OrderAmountTax
        //赋值
        this.creditdataForm.AccountNum = _gt_credit[0].AccountNum

        numbro.zeroFormat("0.00")

        this.creditdataForm.PlantUsedCreditAmount = numbro(
          cust_credit.PlantUsedCreditAmount - data.selected_items[0].OrderAmountTax ///排除当前订单金额
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })

        this.creditdataForm.dispUsedCreditAmount = numbro(
          cust_credit.dispUsedCreditAmount
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })

        //账期
        this.creditdataForm.dispopenInvoiceBalanceMSTDue0 = numbro(
          _gt_credit[0].dispopenInvoiceBalanceMSTDue0
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })

        this.creditdataForm.dispopenInvoiceBalanceMSTDue_N = numbro(
          _gt_credit[0].dispopenInvoiceBalanceMSTDue_N
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })
        this.creditdataForm.dispopenInvoiceBalanceMSTDueAbove_N = numbro(
          _gt_credit[0].dispopenInvoiceBalanceMSTDueAbove_N
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })
        this.creditdataForm.dispopenInvoiceBalanceMSTDue30 = numbro(
          _gt_credit[0].dispopenInvoiceBalanceMSTDue30
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })
        this.creditdataForm.dispopenInvoiceBalanceMSTDue31_60 = numbro(
          _gt_credit[0].dispopenInvoiceBalanceMSTDue31_60
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })
        this.creditdataForm.dispopenInvoiceBalanceMSTDue60Above = numbro(
          _gt_credit[0].dispopenInvoiceBalanceMSTDue60Above
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })
        this.creditdataForm.dataAreaId = data.selected_items[0].dataAreaId
        this.creditdataForm.orderAmount = numbro(
          data.selected_items[0].OrderAmountTax
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })
        this.creditdataForm.creditMax = numbro(
          cust_credit.CreditMax + cust_credit.Temp_CreditMax
        ).format({
          thousandSeparated: true,
          mantissa: 2,
        })

        this.creditdataForm.balance = numbro(_balance_CreditMax).format({
          thousandSeparated: true,
          mantissa: 2,
        })
        // _balance_CreditMax < data.selected_items[0].OrderAmountWOTax * data.selected_items[0].ExchRate
        if (_balance_CreditMax < data.selected_items[0].OrderAmountWOTax) {
          this.textColor = "text-danger"
        } else {
          this.textColor = ""
        }
        this.creditdataForm.approved_comment = ""
        this.$refs.ApprovedCredit.show()
      } else if (data.state == "credit_unapproved") {
        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            let _select_list = _.cloneDeep(data.selected_items)
            let _list = []
            let _update_status_list = check_ap_res.approveStatusIdList
            for (var i in _select_list) {
              let t = _select_list[i]
              let m = {
                type_code: "credit",
                id: t.id,
                approved_comment: "",
                is_so_approved: _state,
              }
              _list.push(m)
            }
            let result = await SOApprovedController.methods.approveData(
              _list,
              this.$global.global_data.local_username,
              _update_status_list
            )
            if (result) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
              //修改审批人及状态
              this.updateApproverAndState(
                data,
                _update_status_list,
                _state,
                "fcCheckSOCreditControlApproved",
                "SOCreditControlApprover"
              )
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      } else if (
        data.state == "price_approved" ||
        data.state == "price_unapproved"
      ) {
        ///价格审批
        let _msg = data.state == "price_approved" ? "审批" : "反审"
        this.msgModal("确定要执行价格" + _msg + "吗？").then(async (v) => {
          if (v) {
            let _select_list = _.cloneDeep(data.selected_items)
            let _list = []
            let _update_status_list = check_ap_res.approveStatusIdList
            for (var i in _select_list) {
              let t = _select_list[i]
              let m = {
                type_code: "price",
                id: t.id,
                is_so_approved: _state,
              }
              _list.push(m)
            }

            let result = await SOApprovedController.methods.approveData(
              _list,
              this.$global.global_data.local_username,
              _update_status_list
            )
            if (result) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
              //修改审批人及状态
              this.updateApproverAndState(
                data,
                _update_status_list,
                _state,
                "fcCheckSOPriceDffApproved",
                "SOPriceDiffApprover"
              )
              ///审批成功后发邮件
              if (_state) {
                let _ep = {
                  notify_type: "price_approve_pass",
                  subject: "so_approve_price_not_pass",
                  idx: "SalesId",
                }
                await this.sendEmailAfterApproved(data.selected_items, _ep)
              }
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      } else if (data.state == "copy") {
        if (data.selected_items.length > 1) {
          this.msgToasts("每次只能复制一条数据!", "info")
          cb(false)
          return
        }
        //数据检查
        if (data.selected_items[0].is_return_so) {
          this.msgToasts("退货单,不能进行复制!", "info")
          cb(false)
          return
        }
        this.msgModal("确定此操作？").then(async (value) => {
          if (value) {
            //调用信用控制
            let _params = {
              company: data.selected_items[0].dataAreaId,
              tableName: "secp_SEI_CustTable2",
              accountNum: data.selected_items[0].InvoiceAccount, //不传则查询所有
            }
            let _res_credit = await CustTableController.methods.pickAndInvoke(
              _params
            )
            if (
              !_.isNull(_res_credit) &&
              _res_credit &&
              _res_credit.status != 0
            ) {
              this.msgToasts(this.$t("notify.ax_error") + "：" + _res_credit.message, "error")
              cb(true)
              return
            } else if (_.isNull(_res_credit)) {
              this.msgToasts(this.$t("notify.ax_call_failed"), "error")
              cb(true)
              return
            }
            //执行复制
            let _result = await SalesOrderController.methods.copySalesOrder({
              SalesId: data.selected_items[0].SalesId,
            })
            if (_result && _result.length > 0) {
              if (_result[0][0].status == 0) {
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true)
                return
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
                return
              }
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
              return
            }
          } else {
            cb(false)
            return
          }
        })

        //1.查询出所有销售订单的明细
        // let _p = [];
        // _.each(data.selected_items, (t) => {
        //   _p.push({ SalesTable_id: t.id });
        // });
        // let _result = await SalesOrderController.methods.getItemDataBySelected(
        //   _p
        // );
        // let _data = { username: this.$global.global_data.local_username };
        // _.each(_result, (t) => {
        //   if (t.Result.Data[0].length == 0) {
        //     this.msgToasts(
        //       "编号:" + t.Params[0].SalesTable_id + " 没有销售订单明细,请检查!",
        //       "info"
        //     );
        //     cb(false);
        //   }
        //   else{
        //      let _item={};
        //      _.each(data.selected_items,s=>{
        //        console.log(s)
        //      });
        //     _.each(t.Result.Data[0],u=>{
        //       console.log(u)
        //     })

        //   }
        // });
        //检查数据并组建json
      }
    },
    ///修改审批人及状态
    updateApproverAndState(
      data,
      _update_status_list,
      _state,
      state_code,
      approver_code
    ) {
      _.each(data.selected_items, (t) => {
        t[state_code] = _state
        let _ap_list = _.find(_update_status_list, { ItemId: t.id })
        //审批后修改审批人及状态
        if (_update_status_list && !_state) {
          if (this.all_role_users.length > 0) {
            let _rn_data = []
            _.each(this.all_role_users, (d) => {
              if (d.role_code == _ap_list.Approver) {
                _rn_data.push(d.username)
              } else {
                t[approver_code] = _ap_list.Approver
              }
            })
            if (_rn_data && _rn_data.length > 0) {
              t[approver_code] = _rn_data.join("，")
            }
          }
          t.is_email_send = false
        } else {
          t[approver_code] = ""
        }
        this.$refs.SOTable1.UpdateItems({ id: t.id }, t)
      })
    },
    ///检查是否已经审批或者反审
    checkIsApproved(items, code, state) {
      let _index = _.findIndex(items, (t) => {
        if (t[code] == state) {
          return t
        }
      })
      return _index > -1
    },
    ///审批后发邮件
    async sendEmailAfterApproved(data, _p) {

      let _groupby_user = _.groupBy(data, "create_by_username")
      ///发邮件给创建人
      await this.exSendEmailAfterApproved(_groupby_user, _p)
      ///根据派发人发送邮件
      let list = []
      for (var i in data) {
        let _m = _.cloneDeep(data[i])
        let cust = _.find(this.$store.state.biz_data.baseData.Customer, {
          AccountNum: _m.CustAccount,
        })
        if (cust && cust.EmailNotifier && cust.EmailNotifier != "") {
          //邮件通知人
          let _dt = _.split(cust.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p)
      }
    },
    async exSendEmailAfterApproved(_groupby_user, _p) {
      let notify_list = []
      for (var d in _groupby_user) {
        let _list = _.filter(_groupby_user[d], (t) => {
          if (
            t.fcCheckSOApproved &&
            t.fcCheckSOCreditControlApproved &&
            t.fcCheckSOPriceDffApproved
          ) {
            return t
          }
        })

        if (_list.length > 0) {
          for (var j in _list) {
            let _result = await SalesOrderController.methods.getItemData({
              SalesTable_id: _list[j].id,
            })

            if (!_.isNull(_result) && _result && _result.length > 0) {
              _list[j].children = []
              _list[j].children = _.map(_result[0], (o) => {
                return { invent_num: o.ItemId, invent_name: o.NameAlias, sales_qty: o.SalesQty }
              })
            }
          }
          let lang_code = notify_template.methods.getUserLangCode(this, d)
          let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

          let _email_params = {
            notify_type: "so_approve_pass", //_p.notify_type,
            subject: email_template["so_approve_pass"], //_p.subject,
            create_by_username: d,
            list: _list,
            idx: _p.idx,
          }
          let _ep = notify_template.methods.getApprovedEmailTemplate(_email_params, this)
          if (!_.isNull(_ep)) {
            notify_list.push(_ep)
          }
        }
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify("add", notify_list)
      }
    },
    tool_invoke(data) { },
    async current_changed(old, current) {
      this.$refs.SOTable2.only_value = false
      this.$refs.SOTable2.only_value1 = false
      if (_.isNull(current)) {
        this.$refs.SOTable3.SetData([])
        this.$refs.SOTable2.SetData([])
        return
      }
      this.isBusy_table3 = true

      ///get cust SaleAreaid
      this.SaleAreaid = await this.getCustSaleAreaid()

      ///get invent
      this.SOTable2_query(false)

      ///get delivery_address
      this.getDeliveryAddress(current.CustAccount, current.dataAreaId)

      //get items
      await this.getSOItems()
      this.isBusy_table3 = false
    },
    async getSOItems() {
      let _this = this
      this.$refs.SOTable3.SetData([])
      let _current_so = this.$refs.SOTable1.GetCurrentItem()
      let _result = await SalesOrderController.methods.getItemData({
        SalesTable_id: _current_so.id,
      })

      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.his_order_line_data = _.cloneDeep(_result[0])
        _.each(_result[0], (t) => {
          t.price_state = t.SalesPrice == t.DiscPrice
          if (_.isNull(t.NameAlias)) {
            t.NameAlias = ""
          }
          t.price_approved_state = t.price_approved_state == 1 ? false : true

          t.old_SalesQty = t.SalesQty
        })
        let _list = _.orderBy(
          _.filter(_result[0], { is_deleted: false }),
          ["LineNum"],
          ["asc"]
        )
        this.$refs.SOTable3.SetData(_list)
      }
    },

    ///初始化 cust
    getBaseDataCust(v) {
      this.cust_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.userInfo.user_custs,
          ["modifiedDateTime"],
          ["desc"]
        )
      ).splice(0, 300)
      this.cust_options = _.filter(this.cust_options, function (o) {
        if (o.Blocked == null || o.Blocked.indexOf("否") != -1) {
          return o
        }
      })
      let _index = _.findIndex(this.cust_options, {
        AccountNum: this.dataForm.CustAccount,
      })
      if (_index < 0 && v == "edit") {
        let _m = _.find(this.$store.state.biz_data.userInfo.user_custs, {
          AccountNum: this.dataForm.CustAccount,
        })
        this.cust_options.push(_m)
      }
    },

    ///筛选cust
    filterMethod(v) {
      this.cust_options = _.cloneDeep(_.orderBy(this.$store.state.biz_data.userInfo.user_custs, ["modifiedDateTime"], ["desc"]))
      this.cust_options = _.filter(this.cust_options, function (o) { return o.Blocked == null || o.Blocked.indexOf("否") != -1 })
      if (v && v != "") {
        this.cust_options = _.filter(this.cust_options, (t) => { return t.AccountNum.indexOf(v) > -1 || t.SEI_Name.indexOf(v) > -1 })
      }
      this.cust_options = this.cust_options.splice(0, 300)
    },
    async CurrencyChanged() {
      let _params = {
        fCur: this.dataForm.CurrencyCode,
        tCur: "CNY",
      }
      let _rate = await ExchRateController.methods.getExchRate(_params)
      if (!_.isNull(_rate) && _rate && _rate.length > 0) {
        if (_.isNull(_rate[0][0].exchange_rate)) {
          this.dataForm.ExchRate = 1
        } else {
          this.dataForm.ExchRate = _rate[0][0].exchange_rate
        }
      }
    },
    //dataAreaChange EVENT
    async dataAreaChanged(val) {
      this.dataForm.TaxGroup = ""
      let company_m = _.find(this.company_options, {
        dataAreaId: this.dataForm.dataAreaId,
      })
      if (company_m) {
        this.dataForm.TaxGroup = company_m.TaxGroup
      }

      let result = await CustTableController.methods.getItemData({
        AccountNum: { "=": this.dataForm.CustAccount },
        dataAreaId: { "=": this.dataForm.dataAreaId },
        Blocked: { "=": "否" },
        is_deleted_ax: { "=": 0 },
      })
      if (result && result.length > 0) {
        this.dataForm.InclTax = result[0][0].InclTax
      }
      ///获取送货地址
      await this.getDeliveryAddress(this.dataForm.CustAccount, this.dataForm.dataAreaId)
    },
    async cutChanged() {
      let _this = this
      this.dataForm.SalesName = ""
      this.dataForm.TaxGroup = ""
      this.dataForm.InvoiceAccount = ""
      this.dataForm.TEC_FinalCustAccount = ""
      this.dataForm.CurrencyCode = ""
      this.dataForm.dataAreaId = ""
      if (this.dataForm.CustAccount != "") {
        let _m = _.find(this.$store.state.biz_data.baseData.Customer, {
          AccountNum: this.dataForm.CustAccount,
        })
        if (_m) {
          this.dataForm.SalesName = _m.SEI_Name
          //this.dataForm.TaxGroup = _m.TaxGroup;
          this.dataForm.InvoiceAccount = this.dataForm.CustAccount
          this.dataForm.TEC_FinalCustAccount = this.dataForm.CustAccount
          this.dataForm.CurrencyCode = _m.Currency
          if (_m.Currency == "CNY") {
            this.dataForm.ExchRate = 1
          } else {
            let _params = {
              fCur: _m.Currency,
              tCur: "CNY",
            }
            let _rate = await ExchRateController.methods.getExchRate(_params)
            if (!_.isNull(_rate) && _rate && _rate.length > 0) {
              this.dataForm.ExchRate = _rate[0][0].exchange_rate
            }
          }
        }
        this.company_options = []
        let _result = await CustTableController.methods.getItemData({
          AccountNum: { "=": this.dataForm.CustAccount },
          Blocked: { "=": "否" },
          is_deleted_ax: { "=": "0" },
        })
        if (!_.isNull(_result) && _result && _result.length > 0) {
          _.each(_result[0], (t) => {
            let _dataArea_m = _.find(
              this.$store.state.biz_data.baseData.CompanyInfo,
              { DataArea: t.dataAreaId }
            )
            if (_dataArea_m) {
              let _cut_m = _.find(
                _this.$store.state.biz_data.baseData.Customer,
                {
                  AccountNum: _dataArea_m.CustAccountNum,
                }
              )
              if (_cut_m)
                t.dataAreaName = _cut_m.SEI_Name
            }
          })
          this.company_options = _.orderBy(_result[0], ["id"], ["asc"])
          let _customer = _.find(
            _this.$store.state.biz_data.baseData.Customer,
            {
              AccountNum: this.dataForm.CustAccount,
            }
          )
          if (
            _customer &&
            _customer.SaleAreaid &&
            !_.isNull(_customer.SaleAreaid)
          ) {
            let _index = _.findIndex(this.company_options, {
              dataAreaId: _customer.SaleAreaid,
            })
            if (_index > -1) {
              this.dataForm.dataAreaId = _customer.SaleAreaid
              this.dataAreaChanged(this.dataForm.dataAreaId)
            } else if (_result[0] && _result[0].length > 0) {
              this.dataForm.dataAreaId = _result[0][0].dataAreaId
              this.dataAreaChanged(this.dataForm.dataAreaId)
            }
          } else if (_result[0] && _result[0].length > 0) {
            this.dataForm.dataAreaId = _result[0][0].dataAreaId
            this.dataAreaChanged(this.dataForm.dataAreaId)
          }
        }


      }
    },
    ///获取送货地址
    async getDeliveryAddress(_CustAccount, _dataAreaId) {
      let result = await SalesOrderController.methods.getDeliveryAddress(
        { CustAccount: _CustAccount, dataAreaId: _dataAreaId }
      )
      if (!_.isNull(result)) {
        let after_order_data = _.orderBy(result[0], "DeliveryAddress")
        this.delivery_address_options = after_order_data
        this.delivery_address_options_group = _.uniqBy(after_order_data, "DeliveryAddress")
      }
    },
    ///获取订单池
    getBaseDataSOPool(_dataAreaId) {
      if (!_.isEmpty(_dataAreaId)) {
        return _.filter(this.$store.state.biz_data.baseData.SalesPool, {
          dataAreaId: _dataAreaId,
        })
      }
      return []
    },
    getBaseDataTaxGroup(_dataAreaId) {
      if (!_.isEmpty(_dataAreaId)) {
        return _.filter(this.$store.state.biz_data.baseData.TaxGroupHeading, {
          dataAreaId: _dataAreaId,
        })
      }
      return []
    },

    //#endregion

    //#region table2
    //查询物料
    async SOTable2_query(itemFilter) {
      this.isBusy_table2 = true
      this.$refs.SOTable2.SetData([])
      let _so_m = this.$refs.SOTable1.GetCurrentItem()
      if (!_so_m || _.isNull(_so_m)) {
        this.isBusy_table2 = false
        this.msgToasts(this.$t("notify.not_selected_data"), "info")
        return
      }
      let _p = {}
      _p.dataAreaId = _so_m.dataAreaId
      if (itemFilter) {
        if (itemFilter.public) {
          _p.publicItem = 1
        }
        if (!itemFilter.allCust) {
          if (_so_m && !_.isNull(_so_m)) {
            _p.CustAccount = _so_m.CustAccount
          }
        }
      } else {
        if (_so_m && !_.isNull(_so_m)) {
          _p.CustAccount = _so_m.CustAccount
        }
      }
      let _result = await InventTableController.methods.getSOInventData(_p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.SOTable2.SetData(
          _.orderBy(_result[0], ["createdDateTime"], ["desc"])
        )
      }

      this.isBusy_table2 = false
    },
    // 物料选择
    SOTable2_Cell_Chose() {
      let _this = this
      let _master_m = this.$refs.SOTable1.GetCurrentItem()
      if (!_master_m || _.isNull(_master_m)) {
        this.msgToasts(this.$t("notify.not_selected_sales_order"), "info")
        return
      }
      if (_.isEmpty(this.$refs.SOTable2.GetSelectedItems())) {
        this.msgToasts(this.$t("notify.not_selected_invent"), "info")
        return
      }

      let _invent_select_items = this.$refs.SOTable2.GetSelectedItems()
      if (_invent_select_items && _invent_select_items.length > 0) {
        // let his_soline_last_num = 0;
        // if (this.his_order_line_data.length > 0) {
        //   his_soline_last_num = _.orderBy(
        //     this.his_order_line_data,
        //     ["LineNum"],
        //     ["desc"]
        //   )[0].LineNum;
        // }
        // let soline_temp_linenum = _.filter(this.$refs.SOTable3.my_data, {
        //   id: "",
        // }).length;
        let _append_items = []
        let _dt = _.cloneDeep(_invent_select_items)
        let _seq = 1
        let his_lineNum = 1
        let cur_lineNum = 1

        if (this.$refs.SOTable3.my_data.length > 0) {
          cur_lineNum =
            parseInt(
              _.orderBy(this.$refs.SOTable3.my_data, ["LineNum"], ["desc"])[0]
                .LineNum
            ) + 1
        }
        if (this.his_order_line_data.length > 0) {
          his_lineNum =
            parseInt(
              _.orderBy(this.his_order_line_data, ["LineNum"], ["desc"])[0]
                .LineNum
            ) + 1
        }
        _seq = cur_lineNum >= his_lineNum ? cur_lineNum : his_lineNum

        // if (this.his_order_line_data.length > 0) {
        //   _seq =
        //     _.orderBy(this.his_order_line_data, ["LineNum"], ["desc"])[0]
        //       .LineNum + 1;
        // } else if (this.$refs.SOTable3.my_data.length > 0) {
        //   _seq =
        //     parseInt(
        //       _.orderBy(this.$refs.SOTable3.my_data, ["LineNum"], ["desc"])[0]
        //         .LineNum
        //     ) + 1;
        // }
        _.each(_dt, (t) => {
          t.id = ""
          t.SalesId = _master_m.SalesId
          t.SalesTable_id = _master_m.id
          t.TaxGroup = _master_m.TaxGroup
          t.CurrencyCode = _master_m.CurrencyCode
          t.dataAreaId = _master_m.dataAreaId
          t.ConfirmedDlv = this.formatDate(
            _master_m.DeliveryDate
          )
          t.SEI_OrderDateCust = this.$date.format(new Date(), "yyyy-MM-dd")
          t.SEI_ShippingDateCust = this.formatDate(
            _master_m.DeliveryDate
          )
          t.price_approved_state = false
          t.LineNum = _seq
          _seq += 1
          let _item = _.cloneDeep(this.dataItemForm)
          for (var i in _item) {
            _item[i] = _.isUndefined(t[i]) ? "" : t[i]
          }
          _item.SalesPrice = 0
          _item.DiscPrice = null
          _item.price_state = false
          if (!_.isNull(t.RetailVariantId) && !_.isEmpty(t.RetailVariantId)) {
            _item.RetailVariantId = t.RetailVariantId
          }
          _item.VariantName = t.VariantName
          _item.DeliveryAddress = _master_m.DeliveryAddress
          _append_items.push(_item)
          _this.getInventData(_item.ItemId, _item)

          // let _index = _.findIndex(this.$refs.SOTable3.my_data, {
          //   ItemId: _item.ItemId
          // });
          // if (_index < 0) {
          //   _append_items.push(_item);
          //   _this.getInventData(_item.ItemId);
          // }
        })

        if (this.$refs.SOTable3.my_data.length > 0) {
          this.$refs.SOTable3.AppendItems(_append_items)
        } else {
          this.$refs.SOTable3.SetData(_append_items)
        }
        if (
          this.$refs.SOTable3.my_data &&
          this.$refs.SOTable3.my_data.length > 50
        ) {
          this.show_pagination = true
        }
        this.$refs.SOTable2.UnSelectAll()
      }
    },
    only_methods(isAllCust, isPublic) {
      this.$refs.SOTable2.SetData([])
      this.SOTable2_query({ allCust: isAllCust, public: isPublic })
    },
    //#endregion

    //#region table3
    ///状态切换
    SOTable3_state_change(data, cb) {
      ///判断是否是自己创建的数据
      let _mt = this.$refs.SOTable1.GetCurrentItem()
      if (!commonController.methods.checkIfCanModifyOrder(this, _mt)) {
        cb(false)
        return
      }

      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        let so_main = this.$refs.SOTable1.GetCurrentItem()
        if (
          so_main &&
          so_main.fcCheckSOApproved &&
          so_main.fcCheckSOCreditControlApproved &&
          so_main.fcCheckSOPriceDffApproved
        ) {
          this.msgToasts("不能删除已审批销售订单明细！", "info")
          cb(false)
          return
        }

        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            let has_id_list = _.filter(
              _.cloneDeep(data.selected_items),
              function (t) {
                return t.id != ""
              }
            )
            let not_id_list = _.filter(
              _.cloneDeep(data.selected_items),
              function (t) {
                return t.id == ""
              }
            )

            if (has_id_list && has_id_list.length > 0) {
              this.isBusy_table3 = true
              let result = await SalesOrderController.methods.deleteItemData(
                has_id_list
              )
              if (!_.isNull(result)) {
                let is_ok = true
                let _error_ids = []
                let check_filter = _.filter(result, {
                  Code: "data/d/SalesLine",
                })
                _.each(check_filter, (t) => {
                  if (t.Result && t.Result.Rollback) {
                    is_ok = false
                    let _m = _.find(_.cloneDeep(data.selected_items), {
                      id: t.Params.id,
                    })
                    if (_m) {
                      _error_ids.push(_m)
                    }
                  }
                })
                if (is_ok) {
                  this.msgToasts(this.$t("notify.action_successfully"), "success")
                  this.$refs.SOTable3.RemoveItems(
                    _.differenceBy(has_id_list, _error_ids, "id")
                  )

                  if (not_id_list.length > 0) {
                    this.$refs.SOTable3.RemoveItems(not_id_list)
                    let _seq =
                      _.orderBy(
                        this.his_order_line_data,
                        ["LineNum"],
                        ["desc"]
                      )[0].LineNum + 1
                    _.each(
                      _.filter(this.$refs.SOTable3.my_data, { id: "" }),
                      (t) => {
                        t.LineNum = _seq
                        _seq += 1
                      }
                    )
                  }
                  _.each(data.selected_items, (t) => {
                    if (_.isInteger(t.id) && t.SalesQty < 0) {
                      let _del_order_list = _.filter(
                        this.$refs.SOTable1.my_data,
                        { id: t.SalesTable_id }
                      )
                      this.$refs.SOTable1.RemoveItems(_del_order_list)
                    }
                  })
                  cb(true)
                  this.isBusy_table3 = false
                } else {
                  this.msgToasts(
                    "删除失败！行号：" +
                    _.join(_.map(_error_ids, "LineNum"), "，") +
                    "，已派单不能删除！",
                    "info"
                  )
                  cb(false)
                }
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
              }
            } else if (not_id_list.length > 0) {
              this.$refs.SOTable3.RemoveItems(not_id_list)

              // let _list = _.filter(this.his_order_line_data, { is_deleted: false })
              let _list = this.his_order_line_data
              let _seq = 1
              if (_list.length > 0) {
                _seq = _.orderBy(_list, ["LineNum"], ["desc"])[0].LineNum + 1
              }
              _.each(_.filter(this.$refs.SOTable3.my_data, { id: "" }), (t) => {
                t.LineNum = _seq
                _seq += 1
              })
            }
          }
        })
      }
    },
    ///检查保存
    async validSaveItems() {
      //检查数量
      let _qty_check_ok = true
      let _deliver_date_check_ok = true
      let _invent_location_ok = true
      let _is_price_ok = true
      _.each(this.$refs.SOTable3.my_data, (t) => {
        if (_.isNull(t.SalesPrice) || t.SalesPrice < 0) {
          _is_price_ok = false
        }
        if (t.SalesQty == 0 || t.SalesQty == "" || _.isNull(t.SalesQty)) {
          _qty_check_ok = false
        }
        if (_.isNull(t.ConfirmedDlv) || t.ConfirmedDlv == "") {
          _deliver_date_check_ok = false
        }
        if (
          _.isNull(t.DW_inventBatchIdSales) ||
          t.DW_inventBatchIdSales == ""
        ) {
          _invent_location_ok = false
        }
      })

      if (!_qty_check_ok) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        return false
      } else if (!_deliver_date_check_ok) {
        this.msgToasts(this.$t("notify.not_delivery_date"), "info")
        return false
      } else if (!_invent_location_ok) {
        this.msgToasts("请选择仓库！", "info")
        return false
      }
      else if (!_is_price_ok) {
        this.msgToasts("价格不能为空或者小于零！", "info")
        return false
      }

      ///检查有派单就不能修改价格
      let _is_can_update_price = true
      let _has_dispatch_list = []
      for (var i in this.$refs.SOTable3.my_data) {
        let t = _.cloneDeep(this.$refs.SOTable3.my_data[i])
        if (_.isInteger(t.id)) {
          let result = await SalesOrderController.methods.getDispatchedQty(
            t.id
          )
          if (!_.isNull(result)) {

            let _td = 0
            if (!_.isNull(result[0][0].totalDispatchedQty)) {
              _td = result[0][0].totalDispatchedQty
            }
            if (_td > 0) {
              let _m = _.find(this.his_order_line_data, { id: t.id })
              if (_m && parseFloat(_m.SalesPrice) != parseFloat(t.SalesPrice)) {
                _is_can_update_price = false
                _has_dispatch_list.push(t.LineNum)
              }
            }
          }
        }
      }

      if (!_is_can_update_price) {
        this.msgToasts(
          "订单行号：" +
          _.join(_has_dispatch_list, "，") +
          "，已经派单不能修改价格！",
          "info"
        )
        return false
      }

      //销售退货不能修改只能重新退货
      let _is_ok = true
      _.each(this.$refs.SOTable3.my_data, (t) => {
        let _m = _.find(this.his_order_line_data, { id: t.id })
        if (_m) {
          if (_m.SalesQty < 0) {
            _is_ok = false
          }
        }
      })
      if (!_is_ok) {
        this.msgToasts("不能修改退货订单，请删除该退货后重新退货！", "info")
        return false
      }
      //已审批订单不能修改
      let _order_m = this.$refs.SOTable1.GetCurrentItem()
      if (_order_m) {
        if (
          _order_m.fcCheckSOApproved == true &&
          _order_m.fcCheckSOCreditControlApproved == true &&
          _order_m.fcCheckSOPriceDffApproved == true
        ) {
          this.msgToasts("该销售订单已审批，不能被修改！", "info")
          return false
        }
      }

      let _params = {
        company: "070",
        tableName: "secp_SEI_CustTable2",
        accountNum: _order_m.CustAccount, //不传则查询所有
      }
      let _gt_credit = await CustTableController.methods.pickAndInvoke(_params)

      if (_.isNull(_gt_credit)) {
        this.msgToasts(this.$t("notify.ax_call_failed"), "error")
        return false
      } else if (
        !_.isNull(_gt_credit) &&
        _gt_credit &&
        _gt_credit.status != 0
      ) {
        this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
        return false
      }
      return true
    },
    ///保存订单明细
    async SOTable3_SaveData(cb) {
      if (this.$refs.SOTable3.my_data.length == 0) {
        cb(true)
        return
      }
      ///判断是否是自己创建的数据
      let _mt = this.$refs.SOTable1.GetCurrentItem()
      if (!commonController.methods.checkIfCanModifyOrder(this, _mt)) {
        cb(true)
        return
      }
      let _order_m = this.$refs.SOTable1.GetCurrentItem()
      if (this.$refs.SOTable3.my_data.length == 0) {
        cb(true)
        return
      }

      ///检查数据
      if (!(await this.validSaveItems())) {
        cb(true)
        return
      }

      let _price_check_list = []
      let _this = this
      ///价格不一致统计
      console.log(this.$refs.SOTable3.my_data)
      _.each(this.$refs.SOTable3.my_data, (t) => {
        if (t.SalesPrice != t.DiscPrice || !_.isNumber(t.DiscPrice)) {
          _price_check_list.push(t)
        }
      })
      ///计算当前订单金额
      let _credit_sum_amount = 0
      let _credit_sum_amount_cny = 0
      let _credit_sum_amount_tax = 0
      let _credit_sum_amount_wotax = 0
      _.each(this.$refs.SOTable3.my_data, (t) => {
        _credit_sum_amount += parseFloat(t.SalesPrice) * parseFloat(t.SalesQty)
      })
      let _amount_m = {
        currency: _order_m.CurrencyCode,
        amount: _credit_sum_amount,
        incTax: _order_m.InclTax == "是" ? 1 : 0,
        taxGroup: _order_m.TaxGroup,
        dataAreaId: _order_m.dataAreaId,
      }
      let _cnyAmount_m =
        await SalesOrderController.methods.getLocalAmountWOTaxData(_amount_m)
      if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
        if (!_.isNull(_cnyAmount_m[0][0].CNYAmount)) {
          _credit_sum_amount_tax = _cnyAmount_m[0][0].CNYAmount
        }
        if (!_.isNull(_cnyAmount_m[0][0].CNYAmountWOTax)) {
          _credit_sum_amount_wotax = _cnyAmount_m[0][0].CNYAmountWOTax
        }
      }
      _credit_sum_amount_cny = _.round(
        parseFloat(_credit_sum_amount) * parseFloat(_order_m.ExchRate),
        2
      )

      let _msg = ""
      ///检查价格是否一致
      if (_price_check_list.length > 0) {
        _msg +=
          "物料编号：" +
          _.map(_price_check_list, "ItemId").join("，") +
          "，订单价格和报价不一致；"//或者协议价格为0
      }
      ///检查客户信用额度(退货不检查)
      ///预测订单不检查
      let cust_credit = await this.getCustCredit(_order_m.CustAccount)
      let _CreditMax =
        cust_credit.CreditMax +
        cust_credit.Temp_CreditMax -
        cust_credit.dispUsedCreditAmount -
        cust_credit.PlantUsedCreditAmount + _credit_sum_amount_tax
      let approve_form = {
        so_amount: _credit_sum_amount,
        so_amount_tax: _credit_sum_amount_tax,
        so_amount_wotax: _credit_sum_amount_wotax,
        cust_credit: _.round(_CreditMax, 2),
        CreditMax: parseFloat(cust_credit.CreditMax),
        Temp_CreditMax: parseFloat(cust_credit.Temp_CreditMax),
        dispUsedCreditAmount: parseFloat(cust_credit.dispUsedCreditAmount),
        PlantUsedCreditAmount: parseFloat(cust_credit.PlantUsedCreditAmount - _credit_sum_amount_tax),
        IsCreditControlOk: true,
        documentCreateByUsername: _order_m.create_by_username,
      }
      if (
        _credit_sum_amount_tax > 0 &&
        _credit_sum_amount_tax > _CreditMax &&
        _order_m.SalesPoolId != '预测订单'
      ) {
        approve_form.IsCreditControlOk = false
        let total_credit = approve_form.CreditMax + approve_form.Temp_CreditMax

        _msg +=
          "信用额度不足（当前订单金额：" +
          _.round(_credit_sum_amount_tax, 2) +
          "，剩余信用额度：" +
          _.round(_CreditMax, 2) +
          "；信用额度+临时信用额度：" +
          _.round(total_credit, 2) +
          "，已使用信用额度：" +
          _.round(approve_form.dispUsedCreditAmount, 2) +
          "，平台已使用信用额度：" +
          _.round(approve_form.PlantUsedCreditAmount, 2) +
          "）；"
      }
      //检查账期
      if (cust_credit && cust_credit.overDueDay) {
        approve_form.IsCreditControlOk = false
        _msg += "存在超期应收货款；"
      }

      ///修改订单金额
      let update_order_amount = {
        id: _order_m.id,
        OrderAmount: _credit_sum_amount,
        OrderAmountCNY: _credit_sum_amount_cny,
        OrderAmountTax: _credit_sum_amount_tax,
        OrderAmountWOTax: _credit_sum_amount_wotax,
        CreditMax: approve_form.CreditMax,
        Temp_CreditMax: approve_form.Temp_CreditMax,
        dispUsedCreditAmount: approve_form.dispUsedCreditAmount,
        PlantUsedCreditAmount: approve_form.PlantUsedCreditAmount,
      }
      if (_msg != "") {
        _msg += "是否继续保存？"
        _this.msgModal(_msg).then((value) => {
          if (value) {
            _this.SOTable3_excut_save(cb, approve_form, update_order_amount)
          } else {
            cb(true)
          }
        })
      } else {
        _this.SOTable3_excut_save(cb, approve_form, update_order_amount)
      }
    },
    ///获取客户信用额度
    async getCustCredit(_CustAccount) {
      // let _cust_credit_amount = 0;
      let _p = {
        CreditMax: 0,
        Temp_CreditMax: 0,
        dispUsedCreditAmount: 0,
        PlantUsedCreditAmount: 0,
        overDueDay: false,
      }
      let cust_credit_result = await CustTableController.methods.getCustCredit({
        AccountNum: _CustAccount,
      })
      if (!_.isNull(cust_credit_result) && cust_credit_result) {
        _p = {
          CreditMax: _.round(cust_credit_result.CreditMax, 2),
          Temp_CreditMax: _.round(cust_credit_result.Temp_CreditMax, 2),
          dispUsedCreditAmount: _.round(
            cust_credit_result.dispUsedCreditAmount,
            2
          ),
          overDueDay: cust_credit_result.overDueDay,
        }
      }

      let plant_cust_used_credit_result =
        await SalesOrderController.methods.getPlantCustUsedCredit({
          accountNum: _CustAccount,
        })
      if (
        plant_cust_used_credit_result &&
        plant_cust_used_credit_result.length > 0
      ) {
        _p.PlantUsedCreditAmount =
          plant_cust_used_credit_result[0][0].plant_customer_used_credit
      }
      return _p
    },
    ///获取客户默认销售公司
    async getCustSaleAreaid() {
      let _SaleAreaid = ""
      let _current_so = this.$refs.SOTable1.GetCurrentItem()
      let _SaleAreaid_result = await CustTableController.methods.getData({
        AccountNum: _current_so.CustAccount,
      })
      if (
        !_.isNull(_SaleAreaid_result) &&
        _SaleAreaid_result &&
        _SaleAreaid_result.length > 0
      ) {
        _SaleAreaid = _SaleAreaid_result[0][0].SaleAreaid
      }
      return _SaleAreaid
    },
    ///保存订单
    async SOTable3_excut_save(cb, approve_form, update_order_amount) {
      let _this = this
      let _so_items = []
      ///当前选择的订单主档
      let so_master_m = this.$refs.SOTable1.GetCurrentItem()
      let _items = _.cloneDeep(this.$refs.SOTable3.my_data)
      for (var i in _items) {
        let _data = _.cloneDeep(_items[i])
        _data.TaxGroup = so_master_m.TaxGroup
        _data.CurrencyCode = so_master_m.CurrencyCode
        _data.dataAreaId = so_master_m.dataAreaId
        if (_data.SalesPriceWOTax == "") {
          _data.SalesPriceWOTax = 0
        }
        if (_data.SalesPriceTax == "") {
          _data.SalesPriceTax = 0
        }

        // ///获取含税价格和非含税价格
        // let _price_tax = {
        //   currency: so_master_m.CurrencyCode,
        //   amount: _data.SalesPrice,
        //   incTax: so_master_m.InclTax == "是" ? 1 : 0,
        //   taxGroup: so_master_m.TaxGroup,
        //   dataAreaId: so_master_m.dataAreaId
        // }
        // let _cnyAmount_m = await SalesOrderController.methods.getLocalAmountWOTaxData(_price_tax)
        // if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
        //   _data.SalesPriceTax = _cnyAmount_m[0][0].CNYAmount
        //   _data.SalesPriceWOTax = _cnyAmount_m[0][0].CNYAmountWOTax
        // }

        if (_.isDate(_data.ConfirmedDlv)) {
          _data.ConfirmedDlv = _this.$date.format(
            _data.ConfirmedDlv,
            "yyyy-MM-dd"
          )
        }
        if (_.isDate(_data.SEI_OrderDateCust)) {
          _data.SEI_OrderDateCust = _this.$date.format(
            _data.SEI_OrderDateCust,
            "yyyy-MM-dd"
          )
        }
        if (_.isDate(_data.SEI_ShippingDateCust)) {
          _data.SEI_ShippingDateCust = _this.$date.format(
            _data.SEI_ShippingDateCust,
            "yyyy-MM-dd"
          )
        }

        delete _data.old_SalesQty
        _data.price_approved_state = _data.SalesPrice == _data.DiscPrice ? 2 : 1

        _data.RemainInventFinancial = 0
        _data.RemainSalesFinancial = 0
        _data.RemainSalesPhysical = 0
        if (_.isInteger(_data.id)) {
          let result = await SalesOrderController.methods.getDispatchedQty(_data.id)
          if (!_.isNull(result)) {
            let _totalDispatchedQty = 0
            if (!_.isNull(result[0][0].totalDispatchedQty)) {
              _totalDispatchedQty = result[0][0].totalDispatchedQty
            }
            _data.valid_remain = parseFloat(_data.SalesQty) - parseFloat(_totalDispatchedQty)
          }
        }
        _so_items.push(_data)
      }

      console.log(_so_items)
      ///待审批数据
      let soForm = {
        id: so_master_m.id,
      }
      if (approve_form && !_.isNull(approve_form)) {
        ///需要写入待审批的数据
        soForm.CustAccount = so_master_m.CustAccount
        soForm.SalesName = so_master_m.SalesName
        soForm.SalesId = so_master_m.SalesId
        soForm.salesorder_amount = approve_form.so_amount //订单金额
        soForm.salesorder_amount_cny = approve_form.so_amount_tax //本币金额
        soForm.salesorder_amount_wotax = approve_form.so_amount_wotax //不含税金额
        soForm.valid_credit = approve_form.cust_credit
        soForm.IsCreditControlOk = approve_form.IsCreditControlOk
        soForm.documentCreateByUsername = approve_form.documentCreateByUsername
        // soForm.SalesPrice
        // soForm.DiscPrice
      }

      console.log(_so_items)
      ///保存数据
      let _rel_save_data =
        await SalesOrderController.methods.saveSalesOrderItems(
          _so_items,
          soForm,
          update_order_amount
        )
      cb(true)
      if (!_.isNull(_rel_save_data)) {
        let _is_ok = true
        //检查能否修改
        let error_notice_list = []
        let _check_list = _.filter(_rel_save_data, {
          Code: "data/u/SalesLine",
        })
        if (_check_list && _check_list.length > 0) {
          _.each(_check_list, (t) => {
            if (t.Result && t.Result.Rollback) {
              _is_ok = false
              let _m = _.find(_.cloneDeep(_so_items), { id: t.Params.id })
              if (_m) {
                error_notice_list.push(_m)
              }
            }
          })
        }
        if (_is_ok) {
          ///成功
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          ///修改界面订单审批状态
          let _so_resault_list = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/s/SalesTable") > -1
          })

          if (_so_resault_list && _so_resault_list.length > 0) {
            _.each(_so_resault_list, (t) => {
              let reOrder = t.Result.Data[0][0]
              reOrder.is_email_send = false
              // console.log(reOrder);
              this.getApprover(reOrder)
              _this.$refs.SOTable1.UpdateItems({ id: reOrder.id }, reOrder)
            })
          }
          ///修改界面明细相关数据
          let _list = _.filter(_rel_save_data, function (t) {
            return (
              t.Code.indexOf("data/i/SalesLine") > -1 ||
              t.Code.indexOf("data/u/SalesLine") > -1
            )
          })
          if (_list && _list.length > 0) {
            _.each(_list, (t) => {
              if (
                t.Result.Data[0][0].DiscPrice == t.Result.Data[0][0].SalesPrice
              ) {
                t.Result.Data[0][0].price_approved_state = 2
              } else {
                t.Result.Data[0][0].price_approved_state = false
              }
              console.log(t.Result.Data[0][0])
              _this.$refs.SOTable3.UpdateItems(
                {
                  ItemId: t.Result.Data[0][0].ItemId,
                  LineNum: t.Result.Data[0][0].LineNum,
                },
                t.Result.Data[0][0]
              )
              let _index = _.findIndex(this.his_order_line_data, {
                id: t.Result.Data[0][0].id,
              })
              if (_index < 0) {
                this.his_order_line_data.push(t.Result.Data[0][0])
              }
            })
          }
        } else {
          this.msgToasts(
            "保存失败，行号：" +
            _.map(error_notice_list, "LineNum").join(",") +
            "，订单数量不能小于已派发数量！",
            "error"
          )
        }
      } else {
        ///失败
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },

    table3_on_input() { },
    table3_on_change: _.debounce(
      async function (data) {

        let _this = this
        ///获取物料报价（必须根据客户默认销售公司）
        if (data.field.key == "SalesQty" || data.field.key == "DeliveryAddress") {
          let result = await SalesOrderController.methods.getDispatchedQty(
            data.item.id
          )
          if (!_.isNull(result)) {
            let _totalDispatchedQty = 0
            if (!_.isNull(result[0][0].totalDispatchedQty)) {
              _totalDispatchedQty = result[0][0].totalDispatchedQty
            }
            data.item.valid_remain =
              parseFloat(data.item.SalesQty) - parseFloat(_totalDispatchedQty)
          }

          data.item.SalesPrice = 0
          data.item.DiscPrice = null
          ///获取物料报价
          await _this.getInventPrice(data.item)
        } else if (data.field.key == "SalesPrice") {
          if (!_.isNull(data.item.DiscPrice)) {
            data.item.price_state = data.item.SalesPrice == data.item.DiscPrice
          }
          if (data.item.SalesPrice && data.item.SalesPrice != "") {
            let so_master_m = this.$refs.SOTable1.GetCurrentItem()
            ///获取含税价格和非含税价格
            let _price_tax = {
              currency: so_master_m.CurrencyCode,
              amount: data.item.SalesPrice,
              incTax: so_master_m.InclTax == "是" ? 1 : 0,
              taxGroup: so_master_m.TaxGroup,
              dataAreaId: so_master_m.dataAreaId,
            }
            let _cnyAmount_m =
              await SalesOrderController.methods.getLocalAmountWOTaxData(
                _price_tax
              )
            if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
              if (!_.isNull(_cnyAmount_m[0][0].CNYAmount)) {
                data.item.SalesPriceTax = _cnyAmount_m[0][0].CNYAmount
              }
              if (!_.isNull(_cnyAmount_m[0][0].CNYAmountWOTax)) {
                data.item.SalesPriceWOTax = _cnyAmount_m[0][0].CNYAmountWOTax
              }
            }
          }
        } else if (data.field.key == "RetailVariantId") {
          let _m = _.find(this.invent_retail_options, {
            ItemId: data.item.ItemId,
          })

          if (_m) {
            let _t = _.find(_m.options, {
              RetailVariantId: data.item.RetailVariantId,
            })
            if (_t) {
              data.item.VariantName = _t.VariantName
            }
          }
        } else if (data.field.key == "ConfirmedDlv") {
          data.item.SEI_ShippingDateCust =
            this.formatDate(data.item.ConfirmedDlv)
        }
      },
      200,
      { leading: false, trailing: true }
    ),
    ///获取物料报价
    async getInventPrice(item) {
      item.SalesPrice = 0
      item.DiscPrice = null
      item.SalesPriceTax = 0
      item.SalesPriceWOTax = 0
      let _so_m = this.$refs.SOTable1.GetCurrentItem()
      ///0616修改为默认销售公司和协议价格没关系,直接取
      // let _sales_id = _so_m.dataAreaId;
      // if (!_.isNull(this.SaleAreaid) && this.SaleAreaid != "") {
      //   _sales_id = this.SaleAreaid
      // }
      let _result = await SalesOrderController.methods.getDiscPrice({
        dataAreaId: _so_m.dataAreaId,
        currency: _so_m.CurrencyCode,
        itemId: item.ItemId,
        accountNum: _so_m.CustAccount,
        qty: Number(item.SalesQty),
        DeliveryAddress: item.DeliveryAddress
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        if (_result[0] && _result[0].length > 0) {
          let _price_m = _result[0][0]
          if (_price_m && !_.isNull(_price_m.price)) {
            item.SalesPrice = _price_m.price
            item.DiscPrice = _price_m.price
          }
        }
      }
      item.price_state = item.SalesPrice == item.DiscPrice
      if (item.SalesQty < 0) {
        item.price_state = false
      }
      if (item.SalesPrice && item.SalesPrice != "") {
        let so_master_m = this.$refs.SOTable1.GetCurrentItem()
        ///获取含税价格和非含税价格
        let _price_tax = {
          currency: so_master_m.CurrencyCode,
          amount: item.SalesPrice,
          incTax: so_master_m.InclTax == "是" ? 1 : 0,
          taxGroup: so_master_m.TaxGroup,
          dataAreaId: so_master_m.dataAreaId,
        }
        let _cnyAmount_m =
          await SalesOrderController.methods.getLocalAmountWOTaxData(
            _price_tax
          )
        if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
          if (!_.isNull(_cnyAmount_m[0][0].CNYAmount)) {
            item.SalesPriceTax = _cnyAmount_m[0][0].CNYAmount
          }
          if (!_.isNull(_cnyAmount_m[0][0].CNYAmountWOTax)) {
            item.SalesPriceWOTax = _cnyAmount_m[0][0].CNYAmountWOTax
          }
        }
      }
      // if (item.SalesPrice != 0 && item.SalesPrice == item.DiscPrice) {
      //   item.price_approved_state = 2;
      // }
      this.$refs.SOTable3.UpdateItems(
        { ItemId: item.ItemId, LineNum: item.LineNum },
        item
      )
    },
    //#endregion

    ///变形编号
    setInventData(_itemId) {
      let _m = _.find(this.invent_retail_options, { ItemId: _itemId })
      if (_m) {
        return _m.options
      }
      return []
    },
    ///获取物料相关信息
    async getInventData(_itemId, _item) {
      if (_.isNull(_itemId)) {
        return
      }
      let so_m = this.$refs.SOTable1.GetCurrentItem()
      let _result = await InventTableController.methods.getItemData({
        dataAreaId: so_m.dataAreaId,
        ItemId: _itemId,
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = _.filter(_result[0], (t) => {
          return t.RetailVariantId != ""
        })
        if (_result[0].length > 0) {
          _item.DW_inventBatchIdSales = _result[0][0].DW_inventBatchIdSales
        }
        let _p = {
          ItemId: _itemId,
          options: _list,
        }
        let _index = _.findIndex(this.invent_retail_options, (t) => {
          return t.ItemId == _p.ItemId
        })
        if (_index < 0) {
          this.invent_retail_options.push(_p)
        }
      }
    },
    ///订单审批邮件模板
    orderEmailTemplate(_selectedlist) {
      let _this = this
      let _params = {}
      let notify_list = []
      _.each(_selectedlist, async (t) => {
        let lang_code = notify_template.methods.getUserLangCode(this, t.SOApprover)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")
        console.log(t)
        let _notify_p = {
          category: "so_approve",
          idx: t.SalesId,
          itemId: t.id,
          notify_type: "so_approve",
          subject: email_template["so_approved_be_care"],
          content: "",
        }
        _params.email_user = t.SOApprover
        _params.main = {
          type_name: "订单审批",
          url: window.location.protocol + "//" + window.location.host + "/sd/SalesOrder?k=" + t.SalesId,
          url_name: window.location.host + "/sd/SalesOrder?k=" + t.SalesId,
          order_code: t.SalesId,
          customer_name: t.SalesName,
          order_pool: t.SalesPoolId,
          order_amount: numbro(t.OrderAmountTax).format({
            thousandSeparated: true,
            mantissa: 2,
          }),
          currency: t.CurrencyCode,
          exch_rate: t.ExchRate,
          tax_group: t.TaxGroup,
          credit_amount: numbro(t.CreditMax + t.Temp_CreditMax).format({
            thousandSeparated: true,
            mantissa: 2,
          }),
          credit_amount_dis: numbro(
            t.CreditMax +
            t.Temp_CreditMax -
            t.dispUsedCreditAmount -
            t.CustomerNotDispatchAmt
          ).format({
            thousandSeparated: true,
            mantissa: 2,
          }),
          order_description: t.TEC_Remark == null ? "" : t.TEC_Remark,
          username: this.$global.global_data.local_username,
          create_at: _this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        }

        let _index = _.findIndex(notify_list, { idx: t.SalesId })
        if (_index < 0) {
          _notify_p.content = notify_template.methods.getOrderEmailTemplate(_params, this)
          notify_list.push(_notify_p)
        }
      })
      return notify_list
    },
    ///信用额度审批邮件模板
    async creditEmailTemplate(_selectedlist) {
      let _this = this
      let _params = {}
      let notify_list = []
      for (var i in _selectedlist) {
        let t = _selectedlist[i]
        let lang_code = notify_template.methods.getUserLangCode(this, t.SOCreditControlApprover)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")
        let _notify_p = {
          category: "credit_approve",
          idx: t.SalesId,
          itemId: t.id,
          notify_type: "credit_approve",
          subject: email_template["so_approve_credit_be_care"],
          content: "",
        }
        let _tn = ""
        let _tn_list = []
        let cust_credit = await this.getCustCredit(t.CustAccount)
        if ((t.CreditMax + t.Temp_CreditMax) == 0) {
          _tn_list.push("无信用额度")
        }
        if ((t.CreditMax + t.Temp_CreditMax - t.dispUsedCreditAmount - cust_credit.PlantUsedCreditAmount) < 0) {
          _tn_list.push("信用额度不足")
        }
        if (cust_credit.overDueDay) {
          _tn_list.push("存在超期款")
        }
        _tn = _.join(_tn_list, "，")
        _params.email_user = t.SOCreditControlApprover
        _params.main = {
          type_name: _tn,
          url: window.location.protocol + "//" + window.location.host + "/sd/SalesOrder?k=" + t.SalesId,
          url_name: window.location.host + "/sd/SalesOrder?k=" + t.SalesId,
          order_code: t.SalesId,
          customer_name: t.SalesName,
          order_pool: t.SalesPoolId,
          order_amount: numbro(t.OrderAmountTax).format({
            thousandSeparated: true,
            mantissa: 2,
          }),
          currency: t.CurrencyCode,
          exch_rate: t.ExchRate,
          tax_group: t.TaxGroup,
          credit_amount: numbro(t.CreditMax + t.Temp_CreditMax).format({
            thousandSeparated: true,
            mantissa: 2,
          }),
          credit_amount_dis: numbro(
            t.CreditMax +
            t.Temp_CreditMax -
            t.dispUsedCreditAmount -
            t.CustomerNotDispatchAmt
          ).format({
            thousandSeparated: true,
            mantissa: 2,
          }),
          order_description: t.TEC_Remark == null ? "" : t.TEC_Remark,
          username: this.$global.global_data.local_username,
          create_at: _this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        }

        let _index = _.findIndex(notify_list, { idx: t.SalesId })
        if (_index < 0) {
          _notify_p.content = notify_template.methods.getOrderEmailTemplate(_params, this)
          notify_list.push(_notify_p)
        }
      }
      return notify_list
    },
    validEmailSend(_list) {
      ///判断是否是自己创建的数据
      let _is_my_data = true
      _.each(_list, (t) => {
        if (
          t.create_by &&
          t.create_by != this.$store.state.biz_data.userInfo.user_id
        ) {
          _is_my_data = false
        }
      })
      if (!_is_my_data) {
        this.msgToasts(this.$t("notify.not_created_by_yourself"))
        return false
      }
      return true
    },
    ///send email
    async SendEmail(data) {
      let _this = this
      let _list = _.orderBy(this.$refs.SOTable1.GetSelectedItems(), ["id"], ["desc"])
      ///检查
      if (_list.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }

      let ask = await this.msgModal(this.$t("notify.is_send_email"))
      if (!ask) return

      if (!this.validEmailSend(_list)) return

      let notify_list = []
      //====订单审批
      let order_email_list = _.filter(_list, { fcCheckSOApproved: false })
      let _order_email_temp_list = this.orderEmailTemplate(order_email_list)
      if (_order_email_temp_list.length > 0)
        notify_list = _.union(notify_list, _order_email_temp_list)

      //====发邮件给采购邮件通知人
      let _profit_m = _.find(this.$store.state.biz_data.baseData.SystemSetting, { code: "email_notifier" })
      if (_profit_m && _profit_m.setting_value != "") {
        let m = JSON.parse(_profit_m.setting_value)
        if (m.purchEmailNotifier && m.purchEmailNotifier.length > 0) {
          let eusers = []
          let roles = _.map(this.$store.state.biz_data.userInfo.user_roles_privileges.roles, "code")
          for (var i in m.purchEmailNotifier) {
            if (_.includes(roles, m.purchEmailNotifier[i])) {
              let _result = await RoleManageController.methods.GetRoleUsers(-1, m.purchEmailNotifier[i])
              _result = _.filter(_result, { is_sys: false })
              if (_result && _result.length > 0) {
                _.each(_result, (t) => {
                  eusers.push(t)
                })
              }
            }
            else
              eusers.push(m.purchEmailNotifier[i])
          }
          eusers = _.uniq(eusers)//去除重复项
          let to_purch_notify_list = []
          let to_purch_list = _.cloneDeep(_list)
          for (var d in eusers) {
            if (to_purch_list.length > 0) {
              for (var j in to_purch_list) {
                let _result = await SalesOrderController.methods.getItemData({
                  SalesTable_id: to_purch_list[j].id,
                })

                if (!_.isNull(_result) && _result && _result.length > 0) {
                  to_purch_list[j].children = []
                  to_purch_list[j].children = _.map(_result[0], (o) => {
                    return { invent_num: o.ItemId, invent_name: o.NameAlias, sales_qty: o.SalesQty }
                  })
                }
              }
              let lang_code = notify_template.methods.getUserLangCode(this, eusers[d])
              let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")
              let _email_params = {
                notify_type: "so_email_to_purch", //_p.notify_type,
                subject: email_template["so_purch"], //_p.subject,
                create_by_username: eusers[d],
                list: to_purch_list,
                idx: "SalesId",
              }
              let _ep = notify_template.methods.getApprovedEmailTemplate(_email_params, this)
              if (!_.isNull(_ep))
                to_purch_notify_list.push(_ep)
            }
          }
          if (to_purch_notify_list.length > 0)
            await commonController.methods.sendOrCancelNotify("add", to_purch_notify_list)
        }
      }

      //====邮件模型(信用额度)
      let credit_email_list = _.filter(_list, { fcCheckSOCreditControlApproved: false })
      let _order_credit_list = await this.creditEmailTemplate(credit_email_list)
      if (_order_credit_list.length > 0)
        notify_list = _.union(notify_list, _order_credit_list)

      //=====价格不一致
      let price_diff_email_list = _.filter(_list, { fcCheckSOPriceDffApproved: false })
      let _so_ids = []
      _.each(price_diff_email_list, (t) => {
        _so_ids.push(t.id)
      })
      let _result = await SalesOrderController.methods.getItemDataNoSql({ SalesTable_id: { in: _so_ids } })
      if (price_diff_email_list.length > 0) {
        if (!_.isNull(_result) && _result && _result.length > 0 && _result[0].length > 0) {
          _.each(_list, async (t) => {
            let price_notify_list = []
            let lang_code = notify_template.methods.getUserLangCode(this, t.SOPriceDiffApprover)
            let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

            //邮件模型（价格不一致）
            let _notify_p = {
              category: "price_approve",
              idx: t.SalesId,
              itemId: t.id,
              notify_type: "price_approve",
              subject: email_template["so_approve_price_not_pass"],
              content: "",
            }
            let _main = {
              type_name: "价格不一致",
              url: window.location.protocol + "//" + window.location.host + "/sd/SalesOrder?k=" + t.SalesId,
              url_name: window.location.host + "/sd/SalesOrder?k=" + t.SalesId,
              order_code: t.SalesId,
              order_pool: t.SalesPoolId,
              so_num: t.SalesId,
              so_amount: numbro(t.OrderAmountTax).format({
                thousandSeparated: true,
                mantissa: 2,
              }),
              order_amount: numbro(t.OrderAmountTax).format({
                thousandSeparated: true,
                mantissa: 2,
              }),
              customer_name: t.SalesName,
              username: t.create_by_username ? t.create_by_username : "",
              ap_date: _this.$date.format(
                new Date(),
                "yyyy-MM-dd HH:mm:ss"
              ),
              create_at: _this.$date.format(
                new Date(),
                "yyyy-MM-dd HH:mm:ss"
              ),
            }
            let _item_list = _.filter(_result[0], {
              SalesTable_id: t.id,
            })
            let _items = []
            let _total_amount = 0
            _.each(_item_list, (_it) => {
              let _vname = ""
              if (!_.isNull(_it.VariantName) && _it.VariantName)
                _vname = _it.VariantName

              let _item = {
                SalesLine_id: _it.id,
                lineNum: _it.LineNum,
                itemId: _it.ItemId,
                inventName: _it.NameAlias,
                VariantName: _vname,
                qty: _it.SalesQty,
                order_price: _.round(_it.SalesPrice, 6),
                dic_price: _.round(_it.DiscPrice, 6),
                currencyCode: _it.CurrencyCode,
                so_decription: _it.TEC_CommonRemark,
              }
              _total_amount += parseFloat(_it.SalesQty) * parseFloat(_it.SalesPrice)
              let _item_index = _.findIndex(_items, { SalesLine_id: _it.SalesLine_id })
              if (_item_index < 0) {
                ///协议价格不同或0都要审批和发邮件
                if (_item.order_price != _item.dic_price || parseFloat(_item.dic_price) == 0)
                  _items.push(_item)
              }
            })
            ///计算当前订单金额
            if (t.currencyCode != "CNY")
              _total_amount = parseFloat(_total_amount) * parseFloat(t.ExchRate)

            _main.so_amount = _.round(_total_amount, 2)

            if (_items.length > 0) {
              let _p = {
                main: _main,
                email_user: t.SOPriceDiffApprover,
                items: _.orderBy(_items, ["lineNum"], ["asc"]),
              }
              _notify_p.content = notify_template.methods.getPriceDiffTemplate(_p, this)
              price_notify_list.push(_notify_p)
            }
            if (price_notify_list.length > 0)
              notify_list = _.union(notify_list, price_notify_list)
          })
        }
      }

      if (notify_list.length > 0) {
        let _rsult = await commonController.methods.sendOrCancelNotify(data.code, notify_list)
        if (!_.isNull(_rsult)) {
          _this.msgToasts(this.$t("notify.email_seccess"), "success")
          await commonController.methods.updateEmailSendState("so", _list)
          _.each(_list, (t) => { t.is_email_send = true })
        }
      } else
        this.msgToasts("订单已全部审批不能再次发送邮件！", "info")
    },

    ExchRateChanged() {
      if (this.dataForm.CurrencyCode == "CNY") {
        this.dataForm.ExchRate = 1
      }
    },
    myApproveChange() {
      let _roles = []
      let _username = this.$global.global_data.local_username
      if (this.onlyMyApproved) {
        if (this.$refs.SOTable1.my_data.length == 0) {
          this.onlyMyApproved = false
          this.msgToasts(this.$t("notify.excute_search_before"), "info")
          return
        }
        if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
          _roles = _.map(
            this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
            "code"
          )
        }

        let _list = []
        _.each(this.$refs.SOTable1.my_data, (t) => {
          if (!_.isNull(t.fcGetSOApprover) && t.fcGetSOApprover) {
            let name_or_role = t.fcGetSOApprover.split(",")[0]
            let _is_role = t.fcGetSOApprover.split(",")[1]
            if (_is_role == 1) {
              if (_.includes(_roles, name_or_role)) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            } else {
              if (_username == name_or_role) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            }
          }
          if (
            !_.isNull(t.fcGetSOCreditControlApprover) &&
            t.fcGetSOCreditControlApprover
          ) {
            let name_or_role = t.fcGetSOCreditControlApprover.split(",")[0]
            let _is_role = t.fcGetSOCreditControlApprover.split(",")[1]
            if (_is_role == 1) {
              if (_.includes(_roles, name_or_role)) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            } else {
              if (_username == name_or_role) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            }
          }
          if (
            !_.isNull(t.fcGetSOPriceDiffApprover) &&
            t.fcGetSOPriceDiffApprover
          ) {
            let name_or_role = t.fcGetSOPriceDiffApprover.split(",")[0]
            let _is_role = t.fcGetSOPriceDiffApprover.split(",")[1]
            if (_is_role == 1) {
              if (_.includes(_roles, name_or_role)) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            } else {
              if (_username == name_or_role) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            }
          }
        })
        this.$refs.SOTable1.SetData(_.orderBy(_list, ["id"], ["desc"]))
      } else {
        this.$refs.SOTable1.SetData(this.his_order_list)
      }
    },
    ///检查是否包含该审批权限
    async checkApproveStatus(action_code) {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _selected_list = this.$refs.SOTable1.GetSelectedItems()
      for (var i in _selected_list) {
        let _approve_type = ""
        let t = _selected_list[i]
        if (action_code == "so_approve") {
          _approve_type = ""
        } else if (action_code == "credit_approve") {
          _approve_type = "credit_control"
        } else if (action_code == "price_approve") {
          _approve_type = "price_diff"
        }
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesOrder",
          ApproveType: _approve_type,
          ItemId: t.id,
        })
        let _is_ok = true
        for (var j in _as_result[0]) {
          let at = _as_result[0][j]
          if (at) {
            if (
              _.includes(_roles, at.Approver) ||
              this.$global.global_data.local_username == at.Approver
            ) {
              _is_ok = false
            }
          }
        }
        if (_is_ok && !_.includes(_check_list, t.id)) {
          _check_list.push(t.id)
        }
      }
      return _check_list
    },
  },
}
</script>

<style>
.token {
  width: 150px;
  height: 30px;
  border-bottom: 1px solid #606266;
  text-align: right;
}

.hb_table_so_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 250rem;
}

.hb_table_so_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 75rem;
}

.hb_table_so_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 170rem;
}

.demo-dataForm {}

.demo-dataForm .el-input.is-disabled .el-input__inner {
  color: #6c6c6c;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
